var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(14.2 19.6) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_x2F_Social_x2F_FB-Copy",
    transform: "translate(5.2 1.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_01-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M9.96,1.6H7.744c-2.428,0-4.011,1.709-4.011,4.443V8.094H1.517q-.317,0-.317.342V11.4q0,.342.317.342H3.733v7.519q0,.342.317.342H6.9q.317,0,.317-.342V11.739H9.749q.317,0,.317-.342V8.435c0-.114,0-.228-.106-.228,0-.114,0-.114-.106-.114H7.216V6.271c0-.8.211-1.253,1.161-1.253H9.855q.317,0,.317-.342V1.942A.234.234,0,0,0,9.96,1.6Z",
    transform: "translate(-1.2 -1.6)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.72a7b8244f65b0e718c284ec673315ea.svg";
export { ForwardRef as ReactComponent };